import React, { useState, useEffect } from 'react';
import ResetPasswordOnNextLogin from '@/components/ModifyCSR/ResetPasswordOnNextLogin';
import DisableCsrAuthentication from '@/components/ModifyCSR/DisableCsrAuthentication';
import DeleteCsr from '@/components/ModifyCSR/DeleteCsr';
import UpdateCsrNameAndRoles from '@/components/ModifyCSR/UpdateCsrNameAndRoles';
import ChangeCsrPassword from '@/components/ModifyCSR/ChangeCsrPassword';
import styles from '@/components/ModifyCSR/ModifyCSR.module.scss';
import OboUsage from '@/components/ModifyCSR/OboUsage';
import Verification from '@/components/ModifyCSR/Verification';
import { getCsrUser } from '@/services/api/csrdata.service';
import API_STATES from '@/constants/StateConstants';
import { ByzzerMask } from '../General/ByzzerMask/ByzzerMask';

function ProfileSettings(props) {
    const [csrDetails, setCsrDetails] = useState({
        status: API_STATES.none,
        error: '',
        result: {},
    });

    const csrEmail = props.csrEmail;

    async function fetchCsrUser() {
        setCsrDetails({
            status: API_STATES.loading,
            error: '',
            result: {},
        });

        const result = await getCsrUser(csrEmail);

        switch (result.status) {
            case API_STATES.success:
                setCsrDetails({
                    status: API_STATES.success,
                    error: '',
                    result: result.data,
                });
                break;
            case API_STATES.error:
                setCsrDetails({
                    status: API_STATES.error,
                    error: result.error,
                    result: {},
                });
                break;
            default:
                setCsrDetails({
                    status: API_STATES.none,
                    error: '',
                    result: {},
                });
        }
    }

    useEffect(() => {
        if (props.csrEmail) {
            fetchCsrUser();
        }
    }, [props.csrEmail]);

    return (
        <>
            <ByzzerMask loading={csrDetails.status === API_STATES.loading} />
            <section className={styles.section}>
                <h3>Verification</h3>
                <Verification
                    isVerified={csrDetails.result?.emailVerified}
                    email={csrEmail}
                    csrId={csrDetails.result?.id}
                />
            </section>

            <section className={styles.section}>
                <h3>Change Settings</h3>
                <ResetPasswordOnNextLogin
                    email={csrEmail}
                    csrPasswordChanged={props.csrPasswordChanged}
                    csrDetails={csrDetails}
                />
                <DisableCsrAuthentication email={csrEmail} />
            </section>

            <UpdateCsrNameAndRoles email={csrEmail} csrDetails={csrDetails} />

            <ChangeCsrPassword email={csrEmail} onCsrPasswordChange={props.onCsrPasswordChange} />

            <DeleteCsr email={csrEmail} onDelete={props.onDelete} />

            <section className={styles.section}>
                <h3>View OBO Activity</h3>
                <OboUsage email={csrEmail} />
            </section>
        </>
    );
}
export default ProfileSettings;
